// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productDetailsSummaryStyles } from "@ces/App/Components/ProductDetails/ProductDetailsSummary";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { css } from "styled-components";

productDetailsSummaryStyles.container = {
    css: css`
        display: flex;
        justify-content: space-between;
        /* in case we have list variants */
        ul {
            display: flex;
        }
    `,
};

productDetailsSummaryStyles.leftSection = {
    css: css`
        display: flex;
        gap: 22px;
    `,
};

productDetailsSummaryStyles.rightSection = {
    css: css`
        min-width: 285px;
    `,
};

productDetailsSummaryStyles.productImage = {
    width: "91px",
    height: "91px",
};

productDetailsSummaryStyles.brandStyles = {
    nameLink: {
        typographyProps: {
            weight: fontConfig.weight.bold,
            color: "text.link",
            size: "12px",
            css: css`
                && {
                    line-height: 13px;
                    display: block;
                }
            `,
        },
    },
};

productDetailsSummaryStyles.productTitle = {
    size: 14,
    lineHeight: "16px",
    weight: fontConfig.weight.bold,
    css: css`
        margin-bottom: 8px;
    `,
};

productDetailsSummaryStyles.titleWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        max-width: 540px;
    `,
};
